import {getConfig} from 'config';
import {getData, postData} from '../dataProvider';

export const savePreLaunchChecks = (data) => {
  return postData(`${getConfig('preLaunchCheckSaveUrl')}`, data, { responseType: 'json' });
};
